<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <component
      id="etrp-chart-header"
      v-if="!timeout"
      :is="chartType+'Chart'"
      :chartId="chartId"
      :data="chartData"
      :options="chartOptions"
    ></component>
    <div v-if="timeout" class="text-center">
      <i class="fa fa-refresh fa-5x text-danger" aria-hidden="true"></i>
      <p>{{name}}</p>
      <p
        class="text-muted"
      >Sorry, we've been unable to refresh the chart data whilst the feed is updating, we will try again soon.</p>
    </div>
    <b-tooltip
      target="etrp-chart-header"
      triggers="hover"
    >ETRP Status doughnut shows the state of the recent Electronic Ticket Receipt Processor actions. Hover over a segment to see more.</b-tooltip>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import randomColor from "randomcolor";
import moment from "moment";

import DonutChart from "@/pages/private/charts/Donut-chart";
import shortid from "shortid";

export default {
  name: "ETRPChart",
  props: ["tile", "refresh"],
  components: {
    DonutChart,
  },
  data() {
    return {
      busy: false,
      timeout: false,
      name: "ETRP Chart",
      chartId: shortid.generate(),
      defaultOptions: {
        palette: [
          {
            name: "never",
            backgroundColor: "rgba(71,153,235,0.1)",
            borderColor: "#6c757d",
            pointHoverBackgroundColor: "#549c60",
            borderWidth: 2,
          },
          {
            name: "today",
            backgroundColor: "rgba(46,184,92,0.1)",
            borderColor: "#2eb85c",
            pointHoverBackgroundColor: "#2eb85c",
            borderWidth: 2,
          },
          {
            name: "yesterday",
            backgroundColor: "rgba(249,177,21,0.1)",
            borderColor: "#f9b115",
            pointHoverBackgroundColor: "#f9b115",
            borderWidth: 2,
          },
          {
            name: "older",
            backgroundColor: "rgba(229,83,83,0.1)",
            borderColor: "#e55353",
            pointHoverBackgroundColor: "#e55353",
            borderWidth: 2,
          },
        ],
        donut: {
          responsive: true,
          maintainAspectRatio: true,
          datalabels: {
            display: false,
          },
          hole: {
            display: true,
            text: "OK",
          },
          title: {
            display: true,
            text: "ETRP Chart",
          },
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 10,
              display: true,
              fontSize: 10,
            },
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var total = dataset.data.reduce(function (
                  previousValue,
                  currentValue,
                  currentIndex,
                  array
                ) {
                  return previousValue + currentValue;
                });
                var currentValue = dataset.data[tooltipItem.index];
                var percentage = currentValue; //parseFloat((currentValue / total) * 100 + 0.5).toFixed(2);

                let raw = dataset.raw[tooltipItem.index];
                return raw.key + " : " + raw.value;
                // return percentage + "%";
              },
              //   afterLabel: function(tooltipItem, data) {
              //     let raw =
              //       data.datasets[tooltipItem.datasetIndex].raw[
              //         tooltipItem.index
              //       ];
              //     // console.log(raw);
              //     return [
              //       "Name: " + raw.key,
              //       "Value: " + raw.value,
              //     ];
              //   }
            },
          },
          onClick: function (evt, item) {
            var activePoints = this.getElementsAtEvent(evt);
            var firstPoint = activePoints[0];
            console.log("donut click", evt, item, activePoints, firstPoint);
          },
        },
      },
      chartData: null,
      chartOptions: null,
      chartEvents: null,
    };
  },
  async mounted() {
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    ...mapGetters(["user"]),
    chartType() {
      if (!this.tile.settings) {
        return "Donut";
      }
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Donut";
      }
    },
  },
  methods: {
    async loadChart() {
      if (!this.tile.settings) return;

      let setting = null;

      this.timeout = false;
      this.busy = true;
      let variables = {
        // email: this.user.email
      };

      setting = this.tile.settings.find((o) => o.key == "server");
      if (setting) {
        variables.source = setting.value;
        this.source = setting.value;
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query chart_etrp($name: String, $source: String) {
              chart_etrp(name: $name, source: $source) {
                labels
                datasets {
                  data
                }
                raw {
                  key
                  value
                }
              }
            }
          `,
          variables,
        });
        if (!response.data.chart_etrp) {
          this.busy = false;
          this.timeout = true;
          return;
        }
        if (response.data.chart_etrp.datasets.length == 0) {
          this.busy = false;
          this.timeout = true;
          return;
        }

        let values = response.data.chart_etrp.datasets[0].data;
        let total = values.reduce(function (
          previousValue,
          currentValue,
          currentIndex,
          array
        ) {
          return previousValue + currentValue;
        });
        let newvalues = [];
        for (var i = 0; i < values.length; i++) {
          var currentValue = values[i];
          var percentage = parseFloat(
            (currentValue / total) * 100 //+ 0.5
          ).toFixed(2);
          newvalues.push(percentage);
        }

        this.chartData = {
          labels: response.data.chart_etrp.labels,
          datasets: [
            {
              backgroundColor: [],
              data: newvalues,
              raw: response.data.chart_etrp.raw,
            },
          ],
        };

        //FIND THE DATE AND PUSH THE COLOUR
        for (var i = 0; i < response.data.chart_etrp.raw.length; i++) {
          let colour = this.defaultOptions.palette.find(
            (o) => o.name == "never"
          );

          let item = response.data.chart_etrp.raw[i];

          let hours = 0;
          switch (item.key) {
            case "launched":
            case "last_data_from_gal":
            case "last_data_from_sabre":
            case "coupons_gal_at":
            case "coupons_sabre_at":
            case "coupons_other_at":
            case "last_update_time":
              hours = this.$moment().diff(
                this.$moment(
                  response.data.chart_etrp.raw[i].value,
                  "DD/MM/YYYY HH:mm"
                ),
                "hours"
              );

              if (hours <= 24) {
                colour = this.defaultOptions.palette.find(
                  (o) => o.name == "today"
                );
              }

              if (hours > 24 && hours <= 48) {
                colour = this.defaultOptions.palette.find(
                  (o) => o.name == "yesterday"
                );
              }
              if (hours > 48) {
                colour = this.defaultOptions.palette.find(
                  (o) => o.name == "older"
                );
              }
              break;

            default:
          }

          this.chartData.datasets[0].backgroundColor.push(colour.borderColor);
        }

        // GET THE DEFAULT OPTIONS FOR THE CHART TYPE
        this.chartOptions = this.defaultOptions[this.chartType];
        let setting = null;

        setting = this.tile.settings.find((o) => o.key == "title");
        if (setting.value) {
          this.chartOptions.title = {
            display: true,
          };
          setting = this.tile.settings.find((o) => o.key == "titletext");
          if (setting) {
            // REPLACE LATER WITH FORMATTED
            let titletext = "ETRP ( " + variables.source + " )";
            // let titletext = this.name + " ( " + variables.source + " )";
            if (variables.daterange) {
              titletext +=
                " " +
                this.$moment(
                  variables.daterange.split("-")[0],
                  "DD/MM/YYYY"
                ).format("MMM YYYY") +
                " slice";
            }
            this.chartOptions.title.text = titletext;
          }
        } else {
          this.chartOptions.title = {
            display: false,
          };
        }

        setting = this.tile.settings.find((o) => o.key == "legend");
        if (setting.value) {
          this.chartOptions.legend = {
            display: true,
          };
          setting = this.tile.settings.find((o) => o.key == "legendposition");
          if (setting) {
            this.chartOptions.legend.position = setting.value;
          }
          this.chartOptions.legend.labels = { boxWidth: 12 };
        } else {
          this.chartOptions.legend = {
            display: false,
          };
        }

        setting = this.tile.settings.find((o) => o.key == "datalabels");
        if (setting.value) {
          this.chartOptions.datalabels = {
            display: true,
          };
        } else {
          this.chartOptions.datalabels = {
            display: false,
          };

        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
      await this.$emit("refreshed");
    },
  },
};
</script>

<style>
</style>